import AsyncStorage from '@react-native-async-storage/async-storage';
let _profUserId = 'default';
try { require('@react-native-async-storage/async-storage').default.getItem('userToken').then(t=>{if(t)_profUserId=t.slice(0,16);}).catch(()=>{}); } catch(e) {}

import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
  View, Text, StyleSheet, TouchableOpacity, ScrollView, SafeAreaView, StatusBar,
  Image, TextInput, FlatList, RefreshControl, ActivityIndicator, Linking, Alert,
  Modal, Animated, Share, Dimensions, KeyboardAvoidingView, Platform,
} from 'react-native';
import { Ionicons, FontAwesome5, MaterialCommunityIcons } from '@expo/vector-icons';
import { useNavigation, useFocusEffect } from '@react-navigation/native';
import { apiFetch } from '../../utils/apiClient';
import useProfile from '../../hooks/useProfile';
import ProfileManagementService from '../../services/ProfileManagementService';
import PROFILE_KEYS from '../../constants/profileKeys';

let LinearGradient;
try { LinearGradient = require('expo-linear-gradient').LinearGradient; } catch {
  LinearGradient = ({colors,style,children,...p}) => <View style={[style,{backgroundColor:colors?.[0]||'#0e4e96'}]} {...p}>{children}</View>;
}

const { width } = Dimensions.get('window');
const API_BASE = 'https://api.jobeng.ai';
const API_KEY  = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
// ─── Shared keys ─────────────────────────────────────────────────────────────
const SHARED = {
  PORTAL_APPS : 'intern_portal_applications',
  PROGRAMS    : 'intern_programs',
  SAVED       : 'studentData',
};
const mkId = () => `app_${Date.now()}_${Math.random().toString(36).slice(2,6)}`;
const loadStudentProfile = async () => {
  try { const r=await AsyncStorage.getItem(SHARED.SAVED); if(r){const d=JSON.parse(r);return d.profile||{};} } catch {} return {};
};
const loadStudentApps = async () => {
  try { const r=await AsyncStorage.getItem(SHARED.PORTAL_APPS); if(r) return JSON.parse(r)||[]; } catch {} return [];
};
const submitToPortal = async (newApp) => {
  try {
    const existing = await loadStudentApps();
    const merged   = [newApp, ...existing.filter(a=>a.id!==newApp.id)];
    await AsyncStorage.setItem(SHARED.PORTAL_APPS, JSON.stringify(merged));
    const sdRaw = await AsyncStorage.getItem(SHARED.SAVED);
    const sd    = sdRaw ? JSON.parse(sdRaw) : {};
    sd.applications = merged; await AsyncStorage.setItem(SHARED.SAVED, JSON.stringify(sd));
    return true;
  } catch(e) { return false; }
};
const toggleSaveToPortal = async (id, saving) => {
  try {
    const sdRaw = await AsyncStorage.getItem(SHARED.SAVED);
    const sd    = sdRaw ? JSON.parse(sdRaw) : {};
    const saved = sd.savedPrograms || [];
    sd.savedPrograms = saving ? [...new Set([...saved,id])] : saved.filter(x=>x!==id);
    await AsyncStorage.setItem(SHARED.SAVED, JSON.stringify(sd));
  } catch {}
};
const fmtDate = d => { try { return new Date(d).toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'}); } catch { return d||''; } };
const daysLeft = d => Math.ceil((new Date(d)-new Date())/(1000*60*60*24));

// ─── Mock data ────────────────────────────────────────────────────────────────
const MOCK_INTERNSHIPS = [
  { id:'1', title:'Software Engineering Intern', company:'Google UK', location:'London', duration:'3 months', compensation:'£2,500/month', deadline:'2025-08-30', description:'Join our engineering team to develop innovative solutions for Google products used by millions worldwide.', requirements:['CS or related degree','Python, Java or C++','Strong problem-solving','Excellent communication'], logo:'https://logo.clearbit.com/google.com', field:'Technology', isRemote:false, isPaid:true, applicationLink:'https://careers.google.com/internships/', postedDate:'2025-05-15', matchScore:92, rating:4.9, reviews:324, benefits:['Mentorship','Certificate','Networking','Return offer'] },
  { id:'2', title:'Mechanical Engineering Intern', company:'Rolls-Royce', location:'Derby', duration:'6 months', compensation:'£2,000/month', deadline:'2025-07-15', description:'Work alongside engineering teams on cutting-edge aerospace technologies, gaining hands-on experience with turbine design and testing.', requirements:['Mechanical Engineering degree','Fluid dynamics','CAD software','Analytical skills'], logo:'https://logo.clearbit.com/rolls-royce.com', field:'Engineering', isRemote:false, isPaid:true, applicationLink:'https://careers.rolls-royce.com/students-and-graduates', postedDate:'2025-05-10', matchScore:85, rating:4.7, reviews:189, benefits:['Competitive salary','Training programme','Professional qualification support','Travel opportunities'] },
  { id:'3', title:'Data Science Intern', company:'Meta', location:'Remote', duration:'3 months', compensation:'£2,300/month', deadline:'2025-07-25', description:'Apply machine learning and statistical analysis to extract insights from large datasets and help solve complex problems.', requirements:['Data Science/Statistics degree','Python/R','ML algorithms','Strong maths background'], logo:'https://logo.clearbit.com/meta.com', field:'Data Science', isRemote:true, isPaid:true, applicationLink:'https://www.metacareers.com/internships/', postedDate:'2025-05-20', matchScore:88, rating:4.8, reviews:256, benefits:['Remote work','Equipment provided','Learning budget','Networking'] },
  { id:'4', title:'UX Design Intern', company:'Apple', location:'London', duration:'4 months', compensation:'£2,400/month', deadline:'2025-07-01', description:'Join our design team to create intuitive and beautiful user experiences for Apple products and services.', requirements:["Design/HCI degree","Strong portfolio","Figma/Sketch proficiency","User-centered design"], logo:'https://logo.clearbit.com/apple.com', field:'Design', isRemote:false, isPaid:true, applicationLink:'https://www.apple.com/careers/students/', postedDate:'2025-05-12', matchScore:78, rating:4.9, reviews:412, benefits:['Product discounts','Mentorship','Design community','Certificate'] },
  { id:'5', title:'Marketing Intern', company:'Unilever', location:'London', duration:'3 months', compensation:'£1,800/month', deadline:'2025-08-20', description:"Gain hands-on experience in brand management, digital marketing, and consumer insights.", requirements:["Marketing/Business degree","Strong communication","Digital marketing platforms","Analytical mindset"], logo:'https://logo.clearbit.com/unilever.com', field:'Marketing', isRemote:false, isPaid:true, applicationLink:'https://careers.unilever.com/students-and-graduates', postedDate:'2025-05-05', matchScore:65, rating:4.5, reviews:167, benefits:['Brand experience','Mentorship','Potential return offer'] },
  { id:'6', title:'Finance Intern', company:'HSBC', location:'London', duration:'6 months', compensation:'£2,100/month', deadline:'2025-07-10', description:'Work with finance teams on financial analysis, reporting, and strategic planning initiatives.', requirements:["Finance/Accounting degree","Strong analytical skills","Excel proficiency","Attention to detail"], logo:'https://logo.clearbit.com/hsbc.com', field:'Finance', isRemote:false, isPaid:true, applicationLink:'https://www.hsbc.com/careers/students-and-graduates', postedDate:'2025-05-18', matchScore:72, rating:4.6, reviews:203, benefits:['Competitive salary','ACCA study support','Structured rotations'] },
  { id:'7', title:'Research Intern - AI', company:'DeepMind', location:'London', duration:'4 months', compensation:'£2,600/month', deadline:'2025-06-25', description:'Contribute to cutting-edge AI and machine learning research alongside world-class researchers.', requirements:["PhD/MSc CS or AI","Deep learning expertise","Python/TensorFlow/PyTorch","Published research preferred"], logo:'https://logo.clearbit.com/deepmind.com', field:'Research', isRemote:false, isPaid:true, applicationLink:'https://deepmind.com/careers/internships', postedDate:'2025-05-22', matchScore:95, rating:4.9, reviews:98, benefits:['Publication opportunities','Conference attendance','Top researchers','Impact research'] },
  { id:'8', title:'Civil Engineering Intern', company:'Arup', location:'Manchester', duration:'6 months', compensation:'£1,900/month', deadline:'2025-07-05', description:'Work on sustainable infrastructure projects and gain practical experience in civil engineering design.', requirements:["Civil Engineering degree","Structural analysis","AutoCAD","Sustainable design"], logo:'https://logo.clearbit.com/arup.com', field:'Engineering', isRemote:false, isPaid:true, applicationLink:'https://www.arup.com/careers/graduates-and-interns', postedDate:'2025-05-08', matchScore:80, rating:4.7, reviews:134, benefits:['Chartership support','Project experience','Mentoring','Travel'] },
];

const FILTER_OPTIONS = ['All','Technology','Engineering','Design','Marketing','Finance','Research','Remote','Paid'];
const SORT_OPTIONS   = ['Best Match','Deadline','Posted Date','Compensation','Rating'];
const FIELD_COLORS   = { Technology:'#0e4e96', Engineering:'#D97706', Design:'#7C3AED', Marketing:'#DB2777', Finance:'#059669', Research:'#B45309', 'Data Science':'#0891B2', All:'#64748B' };

// ─────────────────────────────────────────────────────────────────────────────
export default function InternshipOpportunitiesScreen() {
  // ── Profile integration (auto-injected) ──
  const profileCtx = useProfile();
  const navigation = useNavigation();

  // ── Data ──────────────────────────────────────────────────────────────────
  const [internships,         setInternships]         = useState([]);
  const [filteredInternships, setFilteredInternships] = useState([]);
  const [publishedPrograms,   setPublishedPrograms]   = useState([]);
  const [isLoading,           setIsLoading]           = useState(true);
  const [refreshing,          setRefreshing]          = useState(false);
  const [error,               setError]               = useState(null);

  // ── Portal sync ───────────────────────────────────────────────────────────
  const [savedIds,       setSavedIds]       = useState(new Set());
  const [appliedIds,     setAppliedIds]     = useState(new Set());
  const [studentProfile, setStudentProfile] = useState({});
  const [syncingId,      setSyncingId]      = useState(null);

  // ── UI ────────────────────────────────────────────────────────────────────
  const [searchQuery,    setSearchQuery]    = useState('');
  const [selectedFilter, setSelectedFilter] = useState('All');
  const [selectedSort,   setSelectedSort]   = useState('Best Match');
  const [viewMode,       setViewMode]       = useState('list'); // list | grid
  const [showSortModal,  setShowSortModal]  = useState(false);
  const [compareList,    setCompareList]    = useState([]);
  const [showCompare,    setShowCompare]    = useState(false);
  const [showQuickApply, setShowQuickApply] = useState(false);
  const [quickApplyItem, setQuickApplyItem] = useState(null);
  const [appForm, setAppForm] = useState({ coverLetter:'', whyInterested:'', relevantExperience:'', availability:'' });
  const [applying, setApplying] = useState(false);
  const [showStats, setShowStats] = useState(true);

  const fadeAnim = useRef(new Animated.Value(0)).current;

  // ── Init ──────────────────────────────────────────────────────────────────
  useEffect(() => {
    loadAll();
    Animated.timing(fadeAnim,{toValue:1,duration:600,useNativeDriver:true}).start();
  }, []);

  useFocusEffect(useCallback(() => { loadPortalSync(); }, []));

  const loadPortalSync = async () => {
    const profile = await loadStudentProfile();
    setStudentProfile(profile);
    const apps = await loadStudentApps();
    setAppliedIds(new Set(apps.map(a=>a.programId)));
    const sdRaw = await AsyncStorage.getItem(SHARED.SAVED);
    if (sdRaw) { const sd=JSON.parse(sdRaw); setSavedIds(new Set(sd.savedPrograms||[])); }
    // Merge published programs
    try {
      const progRaw = await AsyncStorage.getItem(SHARED.PROGRAMS);
      if (progRaw) {
        const pub = JSON.parse(progRaw).filter(p=>p.published);
        setPublishedPrograms(pub);
      }
    } catch {}
  };

  const loadAll = async () => {
    setIsLoading(true); setError(null);
    try {
      // Try API
      const r = await apiFetch('/api/data/jobs?job_type=internship&sort=created_at&order=desc&limit=30');
      if (!r.error && Array.isArray(r.data||r)) {
        const jobs = (r.data||r).map(j => ({
          id:j.id||mkId(), title:j.title||'Internship', company:j.company||'Company',
          location:j.location||'UK', duration:j.duration||'3 months',
          compensation:j.salary?.budget||'Competitive', deadline:j.deadline||new Date(Date.now()+30*86400000).toISOString().split('T')[0],
          description:j.description||'', requirements:j.requirements||[], logo:j.logo||`https://logo.clearbit.com/${(j.company||'company').toLowerCase().replace(/\s/g,'')}.com`,
          field:j.field||'Technology', isRemote:!!j.isRemote, isPaid:true,
          applicationLink:j.applicationLink||null, postedDate:j.created_at?.split('T')[0]||new Date().toISOString().split('T')[0],
          matchScore:Math.floor(Math.random()*30)+65, rating:4.5, reviews:50,
        }));
        if (jobs.length > 0) { setInternships(jobs); await loadPortalSync(); return; }
      }
    } catch {}
    // Fallback to mock
    setInternships(MOCK_INTERNSHIPS);
    await loadPortalSync();
    setIsLoading(false);
  };

  const onRefresh = async () => { setRefreshing(true); await loadAll(); setRefreshing(false); };

  // ── Filtering ─────────────────────────────────────────────────────────────
  useEffect(() => {
    // Merge published programs into list
    const existingIds = new Set(internships.map(x=>x.id));
    const extra = publishedPrograms.filter(p=>!existingIds.has(p.id)).map(p => ({
      id:p.id, title:p.title, company:p.companyName||'Company', location:p.location||'UK',
      duration:(p.duration||'12')+' weeks', compensation:p.stipend_range||p.stipend||'Competitive',
      deadline:p.start_date||new Date(Date.now()+30*86400000).toISOString().split('T')[0],
      description:p.description||'', requirements:(p.requirements||'').split(',').map(s=>s.trim()).filter(Boolean),
      logo:`https://logo.clearbit.com/${(p.companyName||'company').toLowerCase().replace(/\s/g,'')}.com`,
      field:p.department||'Technology', isRemote:p.type==='Virtual', isPaid:true,
      applicationLink:null, postedDate:p.created_at?.split('T')[0]||new Date().toISOString().split('T')[0],
      matchScore:80, rating:4.8, reviews:0, fromPortal:true,
    }));
    const all = [...internships, ...extra];
    let f = [...all];
    const q = searchQuery.toLowerCase();
    if (q) f=f.filter(i=>[i.title,i.company,i.location,i.field].some(s=>(s||'').toLowerCase().includes(q)));
    if (selectedFilter==='Remote') f=f.filter(i=>i.isRemote);
    else if (selectedFilter==='Paid') f=f.filter(i=>i.isPaid);
    else if (selectedFilter!=='All') f=f.filter(i=>i.field===selectedFilter);
    f.sort((a,b) => {
      if (selectedSort==='Best Match')   return (b.matchScore||0)-(a.matchScore||0);
      if (selectedSort==='Deadline')     return new Date(a.deadline)-new Date(b.deadline);
      if (selectedSort==='Posted Date')  return new Date(b.postedDate)-new Date(a.postedDate);
      if (selectedSort==='Compensation') return parseInt((b.compensation||'').replace(/[^0-9]/g,''))-parseInt((a.compensation||'').replace(/[^0-9]/g,''));
      if (selectedSort==='Rating')       return (b.rating||0)-(a.rating||0);
      return 0;
    });
    setFilteredInternships(f);
    setIsLoading(false);
  }, [internships, publishedPrograms, searchQuery, selectedFilter, selectedSort]);

  // ── Actions ───────────────────────────────────────────────────────────────
  const handleToggleSave = async (item) => {
    const nowSaved = !savedIds.has(item.id);
    setSavedIds(prev => { const n=new Set(prev); nowSaved?n.add(item.id):n.delete(item.id); return n; });
    await toggleSaveToPortal(item.id, nowSaved);
  };

  const openQuickApply = (item) => {
    if (appliedIds.has(item.id)) { Alert.alert('Already Applied','Check your Student Portal for status updates.'); return; }
    setQuickApplyItem(item);
    setAppForm({ coverLetter:'', whyInterested:'', relevantExperience:'', availability:'' });
    setShowQuickApply(true);
  };

  const submitQuickApply = async () => {
    if (!appForm.coverLetter.trim()||!appForm.availability.trim()) { Alert.alert('Required','Cover Letter and Availability are required.'); return; }
    const item = quickApplyItem;
    if (item.applicationLink) {
      Alert.alert('External Application','Also open the external link?',[
        {text:'Portal Only',onPress:()=>doSubmit(item)},
        {text:'Both',onPress:()=>{Linking.openURL(item.applicationLink).catch(()=>{}); doSubmit(item);}},
        {text:'Cancel',style:'cancel'},
      ]); return;
    }
    await doSubmit(item);
  };

  const doSubmit = async (item) => {
    setApplying(true);
    const newApp = {
      id:mkId(), programId:item.id, programTitle:item.title, company:item.company,
      status:'Submitted', appliedDate:new Date().toISOString().split('T')[0],
      submittedAt:new Date().toISOString(), progress:10, nextStep:'Initial Review',
      feedback:'Application submitted.', documents:['Resume'], source:'opportunities',
      ...appForm,
      studentName:studentProfile.name||'', studentEmail:studentProfile.email||'',
      studentPhone:studentProfile.phone||'', studentUniversity:studentProfile.university||'',
      studentMajor:studentProfile.major||'', studentGpa:studentProfile.gpa||'',
      studentSkills:studentProfile.skills||[],
    };
    const ok = await submitToPortal(newApp);
    setApplying(false);
    if (ok) {
      setAppliedIds(prev=>new Set([...prev,item.id]));
      setShowQuickApply(false);
      Alert.alert('🎉 Applied!',`Application to ${item.title} at ${item.company} submitted and visible in your Student Portal.`);
    } else { Alert.alert('Error','Could not submit. Please try again.'); }
  };

  const toggleCompare = (item) => {
    setCompareList(prev => {
      if (prev.find(x=>x.id===item.id)) return prev.filter(x=>x.id!==item.id);
      if (prev.length>=3) { Alert.alert('Limit','Compare up to 3 internships.'); return prev; }
      return [...prev,item];
    });
  };

  const handleShare = async (item) => {
    try { await Share.share({ title:item.title, message:`${item.title} at ${item.company}\n${item.compensation} · ${item.location} · ${item.duration}\nDeadline: ${fmtDate(item.deadline)}` }); } catch {}
  };

  // ── Stats ─────────────────────────────────────────────────────────────────
  const stats = {
    total:    filteredInternships.length,
    saved:    savedIds.size,
    applied:  appliedIds.size,
    newApps:  filteredInternships.filter(i=>daysLeft(i.postedDate)>-3).length,
    urgent:   filteredInternships.filter(i=>{ const d=daysLeft(i.deadline); return d>=0&&d<=7; }).length,
  };

  // ─────────────────────────────────────────────────────────────────────────
  // CARDS
  // ─────────────────────────────────────────────────────────────────────────
  const renderListCard = (item) => {
    const days   = daysLeft(item.deadline);
    const isPast = days < 0;
    const urgent = days >= 0 && days <= 7;
    const fc     = FIELD_COLORS[item.field] || '#0e4e96';
    const inCmp  = compareList.some(x=>x.id===item.id);
    return (
      <TouchableOpacity key={item.id} style={[st.card, urgent&&{borderLeftWidth:3,borderLeftColor:'#EF4444'}]}
        activeOpacity={0.93}
        onPress={()=>navigation.navigate('InternshipDetails',{internship:item})}>
        {item.matchScore>=90&&<View style={st.topMatchBadge}><Text style={st.topMatchBadgeT}>🔥 Top Match</Text></View>}
        {item.fromPortal&&<View style={[st.topMatchBadge,{backgroundColor:'#D1FAE5',right:undefined,left:12}]}><Text style={[st.topMatchBadgeT,{color:'#059669'}]}>✓ Verified</Text></View>}

        <View style={st.cardTop}>
          <Image source={{uri:item.logo}} style={st.logo} defaultSource={{uri:'https://via.placeholder.com/48'}}/>
          <View style={{flex:1}}>
            <Text style={st.cardTitle} numberOfLines={1}>{item.title}</Text>
            <Text style={st.cardCo}>{item.company}</Text>
            <View style={st.metaRow}>
              <View style={st.metaItem}><Ionicons name="location-outline" size={12} color="#64748B"/><Text style={st.metaT}>{item.location}</Text></View>
              <View style={st.metaItem}><Ionicons name="time-outline" size={12} color="#64748B"/><Text style={st.metaT}>{item.duration}</Text></View>
              <View style={st.metaItem}><Ionicons name="cash-outline" size={12} color="#10B981"/><Text style={[st.metaT,{color:'#10B981',fontWeight:'600'}]}>{item.compensation}</Text></View>
            </View>
          </View>
          <View style={{gap:6}}>
            <TouchableOpacity style={st.iconBtn} onPress={()=>handleToggleSave(item)}>
              <Ionicons name={savedIds.has(item.id)?'bookmark':'bookmark-outline'} size={17} color={savedIds.has(item.id)?'#667eea':'#94A3B8'}/>
            </TouchableOpacity>
            <TouchableOpacity style={st.iconBtn} onPress={()=>handleShare(item)}>
              <Ionicons name="share-social-outline" size={17} color="#94A3B8"/>
            </TouchableOpacity>
          </View>
        </View>

        <Text style={st.cardDesc} numberOfLines={2}>{item.description}</Text>

        <View style={st.tagsRow}>
          <View style={[st.fieldTag,{backgroundColor:fc+'18',borderColor:fc+'33'}]}>
            <Text style={[st.fieldTagT,{color:fc}]}>{item.field}</Text>
          </View>
          {item.isRemote&&<View style={[st.fieldTag,{backgroundColor:'#ECFDF5',borderColor:'#6EE7B7'}]}><Text style={[st.fieldTagT,{color:'#059669'}]}>Remote</Text></View>}
          {item.matchScore&&<View style={[st.fieldTag,{backgroundColor:'#EEF2FF',borderColor:'#C4B5FD'}]}><Text style={[st.fieldTagT,{color:'#667eea'}]}>{item.matchScore}% Match</Text></View>}
          <View style={[st.fieldTag,{backgroundColor:'#FFF7ED',borderColor:'#FED7AA'}]}>
            <Text style={[st.fieldTagT,{color:urgent?'#EF4444':'#D97706'}]}>
              {isPast?'Closed':urgent?`${days}d left!`:`${fmtDate(item.deadline)}`}
            </Text>
          </View>
        </View>

        <View style={st.cardFoot}>
          <View style={{flexDirection:'row',alignItems:'center',gap:4}}>
            <Ionicons name="star" size={13} color="#F59E0B"/>
            <Text style={st.ratingT}>{item.rating}</Text>
            <Text style={st.reviewT}>({item.reviews})</Text>
            <TouchableOpacity style={[st.cmpBtn,inCmp&&st.cmpBtnOn]} onPress={()=>toggleCompare(item)}>
              <MaterialCommunityIcons name="compare" size={13} color={inCmp?'#FFF':'#667eea'}/>
            </TouchableOpacity>
          </View>
          <View style={{flexDirection:'row',gap:6}}>
            <TouchableOpacity style={[st.detailsBtn]} onPress={()=>navigation.navigate('InternshipDetails',{internship:item})}>
              <Text style={st.detailsBtnT}>Details</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[st.applyBtn, isPast&&{backgroundColor:'#E5E7EB'}, appliedIds.has(item.id)&&{backgroundColor:'#D1FAE5'}, urgent&&!isPast&&!appliedIds.has(item.id)&&{backgroundColor:'#EF4444'}]}
              disabled={isPast||syncingId===item.id}
              onPress={()=>openQuickApply(item)}>
              {syncingId===item.id
                ? <ActivityIndicator size={13} color="#FFF"/>
                : <Text style={[st.applyBtnT, (isPast||appliedIds.has(item.id))&&{color:appliedIds.has(item.id)?'#059669':'#6B7280'}]}>
                    {isPast?'Closed':appliedIds.has(item.id)?'Applied ✓':'Apply'}
                  </Text>
              }
            </TouchableOpacity>
          </View>
        </View>
      </TouchableOpacity>
    );
  };

  const renderGridCard = (item) => {
    const days=daysLeft(item.deadline), isPast=days<0, urgent=days>=0&&days<=7;
    const fc=FIELD_COLORS[item.field]||'#0e4e96';
    return (
      <TouchableOpacity key={item.id} style={[st.gridCard, urgent&&{borderTopWidth:3,borderTopColor:'#EF4444'}]}
        onPress={()=>navigation.navigate('InternshipDetails',{internship:item})}>
        <Image source={{uri:item.logo}} style={st.gridLogo}/>
        <Text style={st.gridTitle} numberOfLines={2}>{item.title}</Text>
        <Text style={st.gridCo}>{item.company}</Text>
        <Text style={[st.gridComp,{color:'#10B981'}]}>{item.compensation}</Text>
        <View style={{flexDirection:'row',gap:4,marginTop:6,flexWrap:'wrap'}}>
          <View style={[st.fieldTag,{backgroundColor:fc+'18',borderColor:fc+'33'}]}><Text style={[st.fieldTagT,{color:fc,fontSize:9}]}>{item.field}</Text></View>
          {item.isRemote&&<View style={[st.fieldTag,{backgroundColor:'#ECFDF5',borderColor:'#6EE7B7'}]}><Text style={[st.fieldTagT,{color:'#059669',fontSize:9}]}>Remote</Text></View>}
        </View>
        <View style={{flexDirection:'row',justifyContent:'space-between',marginTop:8,alignItems:'center'}}>
          <TouchableOpacity style={st.iconBtn} onPress={()=>handleToggleSave(item)}>
            <Ionicons name={savedIds.has(item.id)?'bookmark':'bookmark-outline'} size={15} color={savedIds.has(item.id)?'#667eea':'#94A3B8'}/>
          </TouchableOpacity>
          <TouchableOpacity style={[st.applyBtn,{paddingHorizontal:10,paddingVertical:6},isPast&&{backgroundColor:'#E5E7EB'},appliedIds.has(item.id)&&{backgroundColor:'#D1FAE5'}]}
            disabled={isPast} onPress={()=>openQuickApply(item)}>
            <Text style={[st.applyBtnT,{fontSize:11},(appliedIds.has(item.id))&&{color:'#059669'}]}>{isPast?'Closed':appliedIds.has(item.id)?'Applied ✓':'Apply'}</Text>
          </TouchableOpacity>
        </View>
      </TouchableOpacity>
    );
  };

  // ─────────────────────────────────────────────────────────────────────────
  // MODALS
  // ─────────────────────────────────────────────────────────────────────────
  const renderSortModal = () => (
    <Modal visible={showSortModal} transparent animationType="fade" onRequestClose={()=>setShowSortModal(false)}>
      <TouchableOpacity style={st.sortOverlay} activeOpacity={1} onPress={()=>setShowSortModal(false)}>
        <View style={st.sortCard}>
          <Text style={st.sortCardTitle}>Sort By</Text>
          {SORT_OPTIONS.map(opt=>(
            <TouchableOpacity key={opt} style={[st.sortOpt,selectedSort===opt&&st.sortOptA]} onPress={()=>{setSelectedSort(opt);setShowSortModal(false);}}>
              <Text style={[st.sortOptT,selectedSort===opt&&{color:'#0e4e96',fontWeight:'700'}]}>{opt}</Text>
              {selectedSort===opt&&<Ionicons name="checkmark" size={18} color="#0e4e96"/>}
            </TouchableOpacity>
          ))}
        </View>
      </TouchableOpacity>
    </Modal>
  );

  const renderCompareModal = () => {
    if (compareList.length < 2) return null;
    const rows=[{l:'Stipend',fn:p=>p.compensation},{l:'Duration',fn:p=>p.duration},{l:'Location',fn:p=>p.location},{l:'Match',fn:p=>`${p.matchScore||'-'}%`},{l:'Rating',fn:p=>`${p.rating}⭐`},{l:'Deadline',fn:p=>fmtDate(p.deadline)}];
    return (
      <Modal visible={showCompare} animationType="slide" presentationStyle="pageSheet" onRequestClose={()=>setShowCompare(false)}>
        <SafeAreaView style={{flex:1,backgroundColor:'#FFF'}}>
          <View style={st.cmpHdr}>
            <TouchableOpacity style={st.iconBtn} onPress={()=>setShowCompare(false)}><Ionicons name="close" size={22} color="#64748B"/></TouchableOpacity>
            <Text style={st.cmpHdrTitle}>Compare Internships</Text>
            <TouchableOpacity style={st.iconBtn} onPress={()=>setCompareList([])}><Ionicons name="trash-outline" size={20} color="#EF4444"/></TouchableOpacity>
          </View>
          <ScrollView style={{flex:1,padding:16}} showsVerticalScrollIndicator={false}>
            <View style={{flexDirection:'row',marginBottom:12}}>
              <View style={{width:80}}/>
              {compareList.map(p=>(
                <View key={p.id} style={{flex:1,alignItems:'center',paddingHorizontal:4}}>
                  <Image source={{uri:p.logo}} style={{width:36,height:36,borderRadius:8,marginBottom:4}}/>
                  <Text style={{fontSize:11,fontWeight:'700',color:'#1F2937',textAlign:'center',lineHeight:14}} numberOfLines={2}>{p.title}</Text>
                  <Text style={{fontSize:10,color:'#64748B',textAlign:'center',marginTop:1}}>{p.company}</Text>
                </View>
              ))}
            </View>
            {rows.map(row=>(
              <View key={row.l} style={{flexDirection:'row',paddingVertical:10,borderBottomWidth:1,borderBottomColor:'#F3F4F6',alignItems:'center'}}>
                <Text style={{width:80,fontSize:12,color:'#64748B',fontWeight:'600'}}>{row.l}</Text>
                {compareList.map(p=><Text key={p.id} style={{flex:1,fontSize:13,fontWeight:'600',color:'#1F2937',textAlign:'center'}}>{row.fn(p)}</Text>)}
              </View>
            ))}
            <View style={{flexDirection:'row',gap:8,marginTop:16}}>
              <View style={{width:80}}/>
              {compareList.map(p=>(
                <TouchableOpacity key={p.id} style={[st.applyBtn,{flex:1,justifyContent:'center'}]} onPress={()=>{setShowCompare(false);openQuickApply(p);}}>
                  <Text style={st.applyBtnT}>{appliedIds.has(p.id)?'Applied':'Apply'}</Text>
                </TouchableOpacity>
              ))}
            </View>
          </ScrollView>
        </SafeAreaView>
      </Modal>
    );
  };

  const renderQuickApplyModal = () => {
    const item = quickApplyItem; if(!item) return null;
    return (
      <Modal visible={showQuickApply} animationType="slide" presentationStyle="pageSheet" onRequestClose={()=>setShowQuickApply(false)}>
        <KeyboardAvoidingView style={{flex:1,backgroundColor:'#FFF'}} behavior={Platform.OS==='ios'?'padding':'height'}>
          <View style={st.modalHdr}>
            <TouchableOpacity style={st.iconBtn} onPress={()=>setShowQuickApply(false)}><Ionicons name="close" size={22} color="#64748B"/></TouchableOpacity>
            <Text style={st.modalTitle}>Quick Apply</Text>
            <TouchableOpacity style={[st.applyBtn,applying&&{opacity:0.6}]} onPress={submitQuickApply} disabled={applying}>
              {applying?<ActivityIndicator size={14} color="#FFF"/>:<Text style={st.applyBtnT}>Submit</Text>}
            </TouchableOpacity>
          </View>
          <ScrollView style={{flex:1,padding:16}} keyboardShouldPersistTaps="handled">
            <View style={{flexDirection:'row',backgroundColor:'#EEF2FF',borderRadius:12,padding:12,marginBottom:16,gap:10,alignItems:'center'}}>
              <Image source={{uri:item.logo}} style={{width:42,height:42,borderRadius:10}}/>
              <View style={{flex:1}}>
                <Text style={{fontSize:14,fontWeight:'700',color:'#1F2937'}}>{item.title}</Text>
                <Text style={{fontSize:12,color:'#667eea',marginTop:1}}>{item.company} · {item.compensation}</Text>
              </View>
            </View>
            {studentProfile.name&&(
              <View style={{backgroundColor:'#F0FDF4',borderRadius:10,padding:10,marginBottom:14,flexDirection:'row',gap:8,alignItems:'center'}}>
                <Ionicons name="checkmark-circle" size={15} color="#10B981"/>
                <Text style={{flex:1,fontSize:12,color:'#065F46'}}>Applying as {studentProfile.name} · {studentProfile.university||''}. Profile auto-attached.</Text>
              </View>
            )}
            {[
              {label:'Cover Letter *',key:'coverLetter',multi:true,ph:'Highlight your passion and key skills…'},
              {label:'Why interested? *',key:'whyInterested',multi:true,ph:'What draws you to this specific role?'},
              {label:'Relevant Experience',key:'relevantExperience',multi:true,ph:'Projects, coursework, previous roles…'},
              {label:'Availability *',key:'availability',multi:false,ph:'e.g. Available from July 2025, 12 weeks'},
            ].map(f=>(
              <View key={f.key} style={{marginBottom:14}}>
                <Text style={{fontSize:13,fontWeight:'600',color:'#374151',marginBottom:5}}>{f.label}</Text>
                <TextInput style={{borderWidth:1,borderColor:'#E5E7EB',borderRadius:10,paddingHorizontal:12,paddingVertical:11,fontSize:14,color:'#1F2937',backgroundColor:'#FAFAFA',...(f.multi?{minHeight:88,textAlignVertical:'top'}:{})}}
                  value={appForm[f.key]} multiline={f.multi} numberOfLines={f.multi?4:1}
                  onChangeText={v=>setAppForm(p=>({...p,[f.key]:v}))}
                  placeholder={f.ph} placeholderTextColor="#9CA3AF"/>
              </View>
            ))}
            <View style={{height:24}}/>
          </ScrollView>
        </KeyboardAvoidingView>
      </Modal>
    );
  };

  // ─────────────────────────────────────────────────────────────────────────
  // MAIN RENDER
  // ─────────────────────────────────────────────────────────────────────────
  return (
    <SafeAreaView style={st.root}>
      <StatusBar barStyle="light-content" backgroundColor="#0e4e96"/>

      {/* Header */}
      <LinearGradient colors={['#0e4e96','#1e7be2']} style={st.header}>
        <TouchableOpacity style={st.hdrBtn} onPress={()=>navigation.goBack()}>
          <Ionicons name="arrow-back" size={22} color="#FFF"/>
        </TouchableOpacity>
        <View style={{flex:1,alignItems:'center'}}>
          <Text style={st.hdrTitle}>Internship Opportunities</Text>
          <Text style={st.hdrSub}>{filteredInternships.length} opportunities</Text>
        </View>
        <TouchableOpacity style={st.hdrBtn} onPress={()=>setViewMode(v=>v==='list'?'grid':'list')}>
          <Ionicons name={viewMode==='list'?'grid-outline':'list-outline'} size={20} color="#FFF"/>
        </TouchableOpacity>
      </LinearGradient>

      {/* Stats bar */}
      {showStats&&(
        <View style={st.statsBar}>
          {[{l:'Total',v:stats.total,c:'#0e4e96'},{l:'Saved',v:stats.saved,c:'#667eea'},{l:'Applied',v:stats.applied,c:'#10B981'},{l:'Urgent',v:stats.urgent,c:'#EF4444'}].map((s,i)=>(
            <View key={i} style={st.statCard}><Text style={[st.statNum,{color:s.c}]}>{s.v}</Text><Text style={st.statLbl}>{s.l}</Text></View>
          ))}
        </View>
      )}

      {/* Search */}
      <View style={st.searchWrap}>
        <View style={st.searchBox}>
          <Ionicons name="search-outline" size={18} color="#94A3B8"/>
          <TextInput style={st.searchIn} placeholder="Search roles, companies, locations…"
            value={searchQuery} onChangeText={setSearchQuery} placeholderTextColor="#94A3B8"/>
          {searchQuery?<TouchableOpacity onPress={()=>setSearchQuery('')}><Ionicons name="close-circle" size={18} color="#94A3B8"/></TouchableOpacity>:null}
        </View>
        <TouchableOpacity style={st.sortBtnSm} onPress={()=>setShowSortModal(true)}>
          <Ionicons name="swap-vertical-outline" size={18} color="#0e4e96"/>
        </TouchableOpacity>
      </View>

      {/* Filter chips */}
      <View style={st.filterBar}>
        <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={{paddingHorizontal:14,gap:8,paddingVertical:10}}>
          {FILTER_OPTIONS.map(f=>(
            <TouchableOpacity key={f} style={[st.chip,selectedFilter===f&&{backgroundColor:'#0e4e96',borderColor:'#0e4e96'}]} onPress={()=>setSelectedFilter(f)}>
              <Text style={[st.chipT,selectedFilter===f&&{color:'#FFF'}]}>{f}</Text>
            </TouchableOpacity>
          ))}
        </ScrollView>
      </View>

      {/* Compare bar */}
      {compareList.length>0&&(
        <TouchableOpacity style={st.cmpBar} onPress={()=>setShowCompare(true)}>
          <MaterialCommunityIcons name="compare" size={15} color="#FFF"/>
          <Text style={st.cmpBarT}>Compare {compareList.length}</Text>
          <TouchableOpacity onPress={()=>setCompareList([])} hitSlop={{top:8,bottom:8,left:8,right:8}}>
            <Ionicons name="close" size={15} color="#FFF"/>
          </TouchableOpacity>
        </TouchableOpacity>
      )}

      {/* Content */}
      {isLoading ? (
        <View style={st.loadWrap}><ActivityIndicator size={36} color="#0e4e96"/><Text style={st.loadT}>Loading opportunities…</Text></View>
      ) : error ? (
        <View style={st.loadWrap}>
          <Ionicons name="alert-circle-outline" size={56} color="#EF4444"/>
          <Text style={{fontSize:16,color:'#1F2937',fontWeight:'700',marginTop:12}}>Could not load</Text>
          <Text style={{fontSize:13,color:'#64748B',marginTop:6,textAlign:'center'}}>{error}</Text>
          <TouchableOpacity style={[st.applyBtn,{marginTop:16,paddingHorizontal:24}]} onPress={loadAll}><Text style={st.applyBtnT}>Retry</Text></TouchableOpacity>
        </View>
      ) : (
        <Animated.View style={{flex:1,opacity:fadeAnim}}>
          <FlatList
            data={filteredInternships}
            keyExtractor={i=>i.id}
            numColumns={viewMode==='grid'?2:1}
            key={viewMode}
            renderItem={({item})=>viewMode==='grid'?renderGridCard(item):renderListCard(item)}
            contentContainerStyle={{padding:viewMode==='grid'?8:0,paddingBottom:40}}
            showsVerticalScrollIndicator={false}
            refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} colors={['#0e4e96']}/>}
            ListEmptyComponent={()=>(
              <View style={st.empty}>
                <Ionicons name="search-outline" size={56} color="#CBD5E1"/>
                <Text style={st.emptyT}>No internships found</Text>
                <Text style={st.emptyS}>Try adjusting your search or filters</Text>
                <TouchableOpacity style={st.emptyBtn} onPress={()=>{setSearchQuery('');setSelectedFilter('All');}}>
                  <Text style={st.emptyBtnT}>Clear Filters</Text>
                </TouchableOpacity>
              </View>
            )}
          />
        </Animated.View>
      )}

      {renderSortModal()}
      {renderCompareModal()}
      {renderQuickApplyModal()}
    </SafeAreaView>
  );
}

const st = StyleSheet.create({
  root:         {flex:1,backgroundColor:'#F8FAFC'},
  header:       {paddingHorizontal:14,paddingVertical:12,flexDirection:'row',alignItems:'center'},
  hdrBtn:       {width:36,height:36,borderRadius:10,backgroundColor:'rgba(255,255,255,0.18)',justifyContent:'center',alignItems:'center'},
  hdrTitle:     {fontSize:17,fontWeight:'700',color:'#FFF'},
  hdrSub:       {fontSize:11,color:'rgba(255,255,255,0.8)',marginTop:1},
  statsBar:     {flexDirection:'row',backgroundColor:'#FFF',borderBottomWidth:1,borderBottomColor:'#E2E8F0'},
  statCard:     {flex:1,alignItems:'center',paddingVertical:10},
  statNum:      {fontSize:18,fontWeight:'900'},
  statLbl:      {fontSize:10,color:'#94A3B8',fontWeight:'600',marginTop:1},
  searchWrap:   {flexDirection:'row',paddingHorizontal:14,paddingVertical:10,gap:8,backgroundColor:'#FFF',borderBottomWidth:1,borderBottomColor:'#E2E8F0'},
  searchBox:    {flex:1,flexDirection:'row',alignItems:'center',backgroundColor:'#F1F5F9',borderRadius:12,paddingHorizontal:12,paddingVertical:10,gap:8},
  searchIn:     {flex:1,fontSize:14,color:'#0F172A'},
  sortBtnSm:    {width:44,height:44,borderRadius:12,backgroundColor:'#EFF6FF',justifyContent:'center',alignItems:'center',borderWidth:1,borderColor:'#BFDBFE'},
  filterBar:    {backgroundColor:'#FFF',borderBottomWidth:1,borderBottomColor:'#E2E8F0'},
  chip:         {paddingHorizontal:14,paddingVertical:7,borderRadius:20,backgroundColor:'#F1F5F9',borderWidth:1,borderColor:'#E2E8F0'},
  chipT:        {fontSize:12,color:'#64748B',fontWeight:'600'},
  cmpBar:       {flexDirection:'row',alignItems:'center',gap:8,backgroundColor:'#0e4e96',marginHorizontal:14,marginTop:8,borderRadius:10,padding:10},
  cmpBarT:      {flex:1,color:'#FFF',fontWeight:'600',fontSize:13},
  loadWrap:     {flex:1,justifyContent:'center',alignItems:'center',padding:24},
  loadT:        {marginTop:12,fontSize:14,color:'#64748B'},
  card:         {backgroundColor:'#FFF',marginHorizontal:14,marginTop:12,borderRadius:16,padding:14,elevation:2,shadowColor:'#000',shadowOpacity:0.06,shadowRadius:8},
  topMatchBadge:{position:'absolute',top:10,right:12,backgroundColor:'#FEF3C7',borderRadius:8,paddingHorizontal:8,paddingVertical:3,zIndex:1},
  topMatchBadgeT:{fontSize:10,fontWeight:'700',color:'#D97706'},
  cardTop:      {flexDirection:'row',marginBottom:10,gap:10},
  logo:         {width:46,height:46,borderRadius:10,backgroundColor:'#F1F5F9'},
  cardTitle:    {fontSize:15,fontWeight:'700',color:'#0F172A'},
  cardCo:       {fontSize:13,color:'#64748B',marginTop:1},
  metaRow:      {flexDirection:'row',flexWrap:'wrap',gap:8,marginTop:5},
  metaItem:     {flexDirection:'row',alignItems:'center',gap:3},
  metaT:        {fontSize:11,color:'#64748B'},
  iconBtn:      {width:30,height:30,borderRadius:8,backgroundColor:'#F8FAFC',justifyContent:'center',alignItems:'center',borderWidth:1,borderColor:'#E2E8F0'},
  cardDesc:     {fontSize:13,color:'#64748B',lineHeight:18,marginBottom:10},
  tagsRow:      {flexDirection:'row',flexWrap:'wrap',gap:6,marginBottom:10},
  fieldTag:     {borderRadius:12,borderWidth:1,paddingHorizontal:8,paddingVertical:3},
  fieldTagT:    {fontSize:11,fontWeight:'600'},
  cardFoot:     {flexDirection:'row',justifyContent:'space-between',alignItems:'center'},
  ratingT:      {fontSize:12,color:'#64748B',fontWeight:'600'},
  reviewT:      {fontSize:11,color:'#94A3B8'},
  cmpBtn:       {width:26,height:26,borderRadius:6,backgroundColor:'#EEF2FF',justifyContent:'center',alignItems:'center',marginLeft:6,borderWidth:1,borderColor:'#C4B5FD'},
  cmpBtnOn:     {backgroundColor:'#0e4e96'},
  detailsBtn:   {paddingHorizontal:12,paddingVertical:7,borderRadius:10,backgroundColor:'#F1F5F9',borderWidth:1,borderColor:'#E2E8F0'},
  detailsBtnT:  {fontSize:12,fontWeight:'600',color:'#374151'},
  applyBtn:     {backgroundColor:'#0e4e96',borderRadius:10,paddingHorizontal:16,paddingVertical:8,justifyContent:'center',alignItems:'center'},
  applyBtnT:    {fontSize:13,fontWeight:'700',color:'#FFF'},
  gridCard:     {flex:1,backgroundColor:'#FFF',borderRadius:14,margin:5,padding:12,elevation:1,borderWidth:1,borderColor:'#E2E8F0'},
  gridLogo:     {width:40,height:40,borderRadius:8,marginBottom:8},
  gridTitle:    {fontSize:13,fontWeight:'700',color:'#0F172A',lineHeight:17},
  gridCo:       {fontSize:11,color:'#64748B',marginTop:2},
  gridComp:     {fontSize:11,fontWeight:'600',marginTop:3},
  empty:        {alignItems:'center',paddingVertical:60,paddingHorizontal:24},
  emptyT:       {fontSize:16,fontWeight:'700',color:'#374151',marginTop:12},
  emptyS:       {fontSize:13,color:'#94A3B8',textAlign:'center',marginTop:6},
  emptyBtn:     {marginTop:16,backgroundColor:'#0e4e96',borderRadius:10,paddingHorizontal:20,paddingVertical:10},
  emptyBtnT:    {color:'#FFF',fontWeight:'700',fontSize:14},
  sortOverlay:  {flex:1,backgroundColor:'rgba(0,0,0,0.4)',justifyContent:'flex-end',padding:14},
  sortCard:     {backgroundColor:'#FFF',borderRadius:18,padding:16},
  sortCardTitle:{fontSize:16,fontWeight:'800',color:'#0F172A',marginBottom:12},
  sortOpt:      {flexDirection:'row',justifyContent:'space-between',alignItems:'center',paddingVertical:13,borderBottomWidth:1,borderBottomColor:'#F1F5F9'},
  sortOptA:     {backgroundColor:'#EFF6FF',borderRadius:10,paddingHorizontal:8,marginHorizontal:-8},
  sortOptT:     {fontSize:14,color:'#374151'},
  cmpHdr:       {flexDirection:'row',alignItems:'center',justifyContent:'space-between',padding:16,borderBottomWidth:1,borderBottomColor:'#E5E5EA'},
  cmpHdrTitle:  {fontSize:16,fontWeight:'800',color:'#0F172A'},
  modalHdr:     {flexDirection:'row',alignItems:'center',padding:16,borderBottomWidth:1,borderBottomColor:'#E5E5EA',gap:8},
  modalTitle:   {flex:1,textAlign:'center',fontSize:16,fontWeight:'700',color:'#0F172A'},
});
